/* eslint-disable react/prop-types */
import error_icon from "../../src/assets/404.mp4"

const Error = ({ setProgress }) => {


  return (
    <>
       <div className="error-container w-full flex items-center justify-center h-[100vh]">
       <video
        src={error_icon}
        title="404 page"
        alt="404"
        className="w-[500px] h-[600px]"
        width={500}
        height={600}
        autoPlay
        loop
        muted
    />
    
      </div>
    </>
  );
};

export default Error;